<now-wbsuche-lib-typeahead
  [id]="inputElementId"
  #typeahead
  label="{{ messages.WEITERBILDUNG_EINGABEFELD_LABEL }}"
  iconClass="now-icon now-icon-certificate"
  placeholder="{{ messages.WEITERBILDUNG_EINGABEFELD_INFO }}"
  maxlength="60"
  class="flex-grow-1"
  [initialSearchInput]="(initialSuchwort$ | async) ?? ''"
  [resetOnSubmit]="false"
  (suggestionSelected)="onSelected()"
  [mode]="Mode.Text"
  [hilfstext]="hilfstext"
>
</now-wbsuche-lib-typeahead>
